module.exports = __webpack_public_path__ + "img/salute.b070de3c.svg";